module.exports = __webpack_public_path__ + "static/media/team-4.af8c32a4.webp";